import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { IconType, SvgIcon } from '../General/SvgIcon';

export interface Props {
  title: string;
  id: string;
  active: boolean;
  handleCategoryChange: (id) => void;
}

function SitemapLink({ title, handleCategoryChange, id, active }: Props) {
  return (
    <Wrapper
      active={active}
      // tslint:disable-next-line:jsx-no-lambda
      onClick={() => handleCategoryChange(id)}
    >
      <StyledSvgIcon
        icon={IconType.blogCategory}
        alt="Blog menu"
        width={16}
        height={16}
        marginRight={12}
        cursor="pointer"
        active={active}
      />
      {title}
    </Wrapper>
  );
}

const Wrapper = styled(Link)<{ active: boolean }>`
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(22)};
  text-decoration: none;
  width: fit-content;
  color: ${({ theme, active }) =>
    active ? theme.colors.white : theme.colors.secondary};
  margin-bottom: ${rem(24)};
  margin-right: ${rem(16)};
  font-family: ${({ theme }) => theme.font.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${rem(14)} ${rem(24)};
  border: ${rem(2)} solid
    ${({ theme, active }) =>
      active ? theme.colors.secondary : theme.colors.secondaryTransparent};
  border-radius: 4px;
  transition: all 0.3s ease;
  background-color: ${({ theme, active }) =>
    active ? theme.colors.secondary : theme.colors.white};
  font-weight: 500;
  &:hover {
    border-color: ${({ theme }) => theme.colors.secondary};
  }

  ${({ theme }) => theme.mediab.l925`
     margin: 0;
     margin-right: ${rem(8)};
     min-width: fit-content;
  `}
`;
const StyledSvgIcon = styled(SvgIcon)<{ active: boolean }>`
  fill: ${({ theme, active }) =>
    active ? theme.colors.white : theme.colors.secondary};
`;

export { SitemapLink };
